module.exports = __webpack_public_path__ + "static/media/logo-full.1ff7571a.png";